module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyCloudAccount.chooseTenant.title":"Sharing","copyCloudAccount.chooseTenant.caption":"Choose the cloud connection to copy into which customer.","copyCloudAccount.chooseTenant.share":"Share cloud connection credentials for enhanced services e.g. Recommendations and reservations."}}')
  delete Component.options._Ctor
}
